module.exports = __webpack_public_path__ + "static/img/close-image.426a0e95.png";